import { Vehicle } from '@quorum/models/xs-resource';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

export interface SelectedVehiclesState extends EntityState<Vehicle> {}

export const vehicleAdapter: EntityAdapter<Vehicle> = createEntityAdapter<Vehicle>({
  selectId: (vehicle: Vehicle) => vehicle.id
});
export const initialVehicleState: SelectedVehiclesState = vehicleAdapter.getInitialState({});
